// src/app/services/dashboard-notification.service.ts
import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

export interface NotificationDto {
  id: string;
  sellerID: string;
  module: string;
  module_ID: string;
  title: string;
  message: string;
  created_At: string;
}

export interface PagedNotificationsResponse {
  data: NotificationDto[];
  succeeded: boolean;
  errors: string[];
  message: string;
  pageNumber: number;
  pageSize: number;
  totalPages: number;
  totalRecords: number;
}

@Injectable({ providedIn: 'root' })
export class DashboardNotificationService {
 

  constructor(private http: HttpClient) {}

  getNotifications(
    pageNo: number = 1,
    pageSize: number = 10
  ): Observable<PagedNotificationsResponse> {
    let params = new HttpParams()
      .set('PageNo', pageNo)
      .set('PageSize', pageSize);

    return this.http.get<PagedNotificationsResponse>(
      `${environment.apiUrl}/Dashboard/GetNotifications`,
      { params }
    );
  }
}
